import { Button, Modal, TextInput } from '@mantine/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './AddExternalLinkModal.module.scss';
import { Props } from './AddExternalLinkModal.types';

const AddExternalLinkModal = ({ open, onClose, onValidate, loading }: Props) => {
  const { t } = useTranslation();
  const [name, setName] = useState('');
  const [url, setUrl] = useState('');

  const handleClose = () => {
    setName('');
    setUrl('');
    onClose();
  };

  const handleSubmit = () => {
    if (name.trim() && url.trim()) {
      onValidate({ name: name.trim(), url: url.trim() });
      setName('');
      setUrl('');
    }
  };

  return (
    <Modal
      opened={open}
      onClose={handleClose}
      title={
        <div className={styles.title}>
          {t('documents.externalLink.modalTitle', 'Ajouter un lien externe')}
        </div>
      }
      withCloseButton={true}
    >
      <div className={styles.container}>
        <TextInput
          label={t('documents.externalLink.nameLabel', 'Nom du document')}
          placeholder={t('documents.externalLink.namePlaceholder', 'Ex: Tableau de suivi Drive')}
          disabled={loading}
          value={name}
          onChange={e => setName(e.target.value)}
          mb="sm"
        />
        <TextInput
          label={t('documents.externalLink.urlLabel', 'URL')}
          placeholder="https://docs.google.com/..."
          disabled={loading}
          value={url}
          onChange={e => setUrl(e.target.value)}
          mb="md"
        />
        <div className={styles.buttons}>
          <Button loading={loading} onClick={handleSubmit} disabled={!name.trim() || !url.trim()}>
            {t('documents.externalLink.add', 'Ajouter')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default AddExternalLinkModal;
